import React from 'react';
import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils';
import { textStyle } from './styles';

type ITextProps = React.ComponentProps<'span'> &
  VariantProps<typeof textStyle> & {
    /** React Native compatibility prop — handled via CSS line-clamp on web. */
    numberOfLines?: number;
    /** Android-only; ignored on web. */
    androidBoldTextTrailingSpaces?: number;
    /** Native-only auto-shrink; ignored on web. */
    adjustsFontSizeToFit?: boolean;
    /** Native-only auto-shrink floor; ignored on web. */
    minimumFontScale?: number;
  };

const Text = React.forwardRef<React.ComponentRef<'span'>, ITextProps>(
  function Text(
    {
      className,
      isTruncated,
      bold,
      underline,
      strikeThrough,
      size = 'md',
      sub,
      italic,
      highlight,
      numberOfLines: _numberOfLines,
      androidBoldTextTrailingSpaces: _androidBoldTextTrailingSpaces,
      adjustsFontSizeToFit: _adjustsFontSizeToFit,
      minimumFontScale: _minimumFontScale,
      // Strip React Native–only props that would otherwise leak onto the DOM.
      ...props
    }: { className?: string } & ITextProps,
    ref
  ) {
    return (
      <span
        className={textStyle({
          isTruncated,
          bold,
          underline,
          strikeThrough,
          size,
          sub,
          italic,
          highlight,
          class: className,
        })}
        {...props}
        ref={ref}
      />
    );
  }
);

Text.displayName = 'Text';

export { Text };
